const keyName = require('../../configs/keys')
const { CoreBaseUtile } = require('./public')

const OTHER = keyName.default.other

class FilterGroup extends CoreBaseUtile {
  constructor() {
    super()
    this.baseExp = ''
  }

  // 首次获取过滤分组
  async getFilterGroup(params) {
    const {
      item, searchParams, sideCode, componentGroup
    } = params
    const forbiddenMap = ['SliderGroup']
    if (forbiddenMap.includes(componentGroup)) return // 禁用表存在，改名字直接退出
    const handledParams = this.beforeRequestHandler(item, searchParams, sideCode)
    const searchResult = await this._request(handledParams)
    this.checkDataIsComplete(item, searchResult) // 处理结果和状态
    return searchResult
  }

  // 获取检索列表结果
  async getResultList(params) {
    const searchResultList = await this._request(params)
    return searchResultList
  }

  // 加载更多
  async loadMoreFilterGroup(params) {
    const { item, searchParams, sideCode } = params
    item.page++
    item.pageSize = item.page === 2 ? 50 : 100
    const handledParams = this.beforeRequestHandler(item, searchParams, sideCode)
    const loadMoreResult = await this._request(handledParams)
    this.checkDataIsComplete(item, loadMoreResult) // 处理结果和状态
    return loadMoreResult
  }

  // 基础请求
  async _request(params) {
    const result = await this.$querySearch(params)
    return JSON.parse(result.data)
  }

  // 处理结果，分页显示等状态
  // eslint-disable-next-line class-methods-use-this
  checkDataIsComplete(item, resultInstance) {
    const { hits } = resultInstance
    const { page, pageSize } = item
    item.nextPage = hits >= pageSize && page !== 3 // 不超过三页，以及有更多的数据才是true
    item.onticText = hits === 0 ? '暂无数据' : ''
  }

  // 检索前的参数处理
  beforeRequestHandler(item, searchParams) {
    const {
      name, pageSize
    } = item
    const isPoint = this.isPoint(name) // 是否属于标引
    item.nextPage = !isPoint // 是否展示更多
    const requestCols = this.handlerCols(item) // 处理cols参数
    const requestParams = { // 检索参数
      ...searchParams, // 包含合并类型，检索类型等参数
      offset: 0,
      requestCols, // 别名参数
      pageSize,
      secondSieve: requestCols.alias === 'user_label' // 用于表示此请求为侧栏筛选，后端需要用于判断
    }
    return requestParams
  }

  // 处理别名
  // eslint-disable-next-line class-methods-use-this
  handlerCols(item) {
    const {
      currentIndex, oldKey, name, key
    } = item
    const belongYear = ['公开年', '申请年', '转让年', '许可年', '失效年'] // 特殊处理
    let requestCols
    if (belongYear.includes(oldKey) || belongYear.includes(name)) {
      requestCols = [
        { alias: key, sortType: 'DESC' },
        { alias: OTHER.patentNum }
      ]
    } else {
      const isObjKey = typeof key === 'object'
      const alias = isObjKey ? key[currentIndex] : key
      requestCols = [
        { alias },
        { alias: OTHER.patentNum, sortType: 'DESC' }
      ]
    }
    return requestCols
  }

  // 处理检索式缓存后的前缀问题
  handlerHistoryExp(data, sideCode) {
    data.code = sideCode.code
    if (data.searchExpre) {
      const andNot = data.searchExpre.substr(0, 5)
      if (andNot === ' and ' || andNot === ' not ') {
        data.searchExpre = this.baseExp + data.searchExpre
      } else {
        data.searchExpre = `${this.baseExp} and ${data.searchExpre}`
      }
    } else {
      data.searchExpre = this.baseExp
    }
  }

  // 检查是否为标引
  // eslint-disable-next-line class-methods-use-this
  isPoint(name) {
    return name.indexOf('标引') > -1
  }
}

module.exports = {
  FilterGroup
}
